<template>
    <div
        :class="[$style.imgWrap, isPopup && $style.popup, isSticykbar && $style.stickybar]"
        v-loading="loading"
    >
        <img
            :class="[isErrorImg && $style.errImg]"
            :src="srcValue"
            :alt="props.alt"
            :onerror="handleOnError"
            v-if="isShowImg && !props.isControlGroup"
            :onload="handleOnload"
        />
        <span v-if="props.isControlGroup" :class="$style.control">Original</span>
    </div>
</template>
<script lang="ts">
import { ExperienceListInfoType } from '@models/experience/useExperienceList';
import { Experience } from '@models/experience/experience';
type _experienceDataType = ExperienceListInfoType | Experience;

export default {
    name: 'Thumbnail'
};
</script>

<script lang="ts" setup>
import { ref, watch, computed } from 'vue';

interface Props {
    src: string;
    alt?: string;
    retryTime?: number;
    isControlGroup?: boolean;
    experienceData?: _experienceDataType;
    engageType?: string;
}
const srcValue = ref('');
const props = withDefaults(defineProps<Props>(), {
    retryTime: 6
});
const isShowImg = ref(true);
const maxTime = ref(1);
const loading = ref(false);
const isErrorImg = ref(false);
const delayTimes = Array.from({ length: props.retryTime }, (_, index) => {
    return (index + 1) * 500;
});
const isPopup = computed(() => {
    return ['POPUP'].includes(
        (props.experienceData?.engageType as string) || (props.engageType as string)
    );
});
const isSticykbar = computed(() => {
    return ['STICKY_BAR'].includes(
        (props.experienceData?.engageType as string) || (props.engageType as string)
    );
});
watch(
    () => props.src,
    () => {
        srcValue.value = props.src;
        loading.value = !!props.src;
    },
    {
        immediate: true
    }
);
function handleOnError() {
    if (maxTime.value <= props.retryTime) {
        isShowImg.value = false;
        setTimeout(() => {
            isShowImg.value = true;
        }, delayTimes[maxTime.value - 1]);
        maxTime.value++;
    } else {
        loading.value = false;
        isErrorImg.value = true;
        maxTime.value = 1;
    }
}
function handleOnload() {
    loading.value = false;
    maxTime.value = 1;
}
</script>
<style lang="scss" module>
@import '@style/import.scss';
.imgWrap {
    width: 100%;
    height: 100%;
    border-radius: 4px;
    background-color: #fafbfc;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
        width: 100%;
        height: 100%;
        object-fit: contain;
        &.errImg {
            width: auto;
        }
    }
    &.popup {
        padding: 4px;
        img {
            height: 100%;
            width: 100%;
            max-width: 100%;
        }
    }
    &.stickybar {
        padding: 4px;
        img {
            width: 100%;
            height: 100%;
        }
    }
    .control {
        color: $pt-black-90;
        font-weight: normal;
        font-size: 12px;
    }
}
</style>
